export const Grooming = {
  Never: 'pet-grooming-never',
  EverySixMonths: 'pet-grooming-every-six-months',
  EveryThreeMonths: 'pet-grooming-every-three-months',
  EveryMonth: 'pet-grooming-every-month',
  BackBtn: 'back-btn',
  NextBtn: 'next-btn',
} as const;
